import { instance as axios } from "@/hooks/axios/axios.js";
import errorHandler from "@/store/errors/errorHandler.js";

export const notifications = {
  state: {
    unread: null,
    messages: [],
    messages_meta: {},
  },
  getters: {
    GET_NOTIFICATIONS_DATA: (state) => state,
    GET_NOTIFICATIONS_MESSAGES: (state) => state.messages,
    GET_NOTIFICATIONS_UNREAD: (state) => state.unread,
    GET_NOTIFICATIONS_MESSAGES_META: (state) => state.messages_meta,
  },
  mutations: {
    SET_NOTIFICATIONS_MESSAGES(state, data) {

       state.messages = data.data;

      state.unread = data.unread;
      state.messages_meta = data.meta;
    },
    SET_LOAD_MORE_NOTIFICATIONS_MESSAGES(state, data) {

      data.data.map((item) => {
        if (!state.messages.some((x) => x.id == item.id)) {
          state.messages.push(item);
        }
      });

      state.unread = data.unread;
      state.messages_meta = data.meta;
    },
    ADD_NOTIFICATIONS_MESSAGE(state, data) {
      const messages = state.messages;
      if (!messages.some((x) => x.id == data.id)) {
        state.messages.unshift(data);
      }
    },

    SET_NOTIFICATIONS_UNREAD_MESSAGES(state, data) {
      state.unread = data;
    },
  },
  actions: {
    async GET_NOTIFICATIONS_MESSAGES(store, data) {
      let url = "/notifications";

      try {
        const resp = await axios.get(url, { params: data });

        if (data.action === 'loadMore') { // fixed issue with updating notifications list

          store.commit("SET_LOAD_MORE_NOTIFICATIONS_MESSAGES", resp.data);
        } else {

          store.commit("SET_NOTIFICATIONS_MESSAGES", resp.data);
        }

        // return resp.data
      } catch (error) {
        errorHandler(error);
      }
    },


    async MARK_NOTIFICATION_MESSAGE_AS_READ(store, data) {
      try {
        let url = "/notifications/" + data + "/mark-as-read";

        await axios.put(url);

        const messages = store.state.messages;
        messages.some((x) => {
          if (x.id == data) {
            x.status = 1;
            return true;
          }
          return false;
        });
      } catch (error) {
        errorHandler(error);
      }
    },
  },
};
